import { render, staticRenderFns } from "./FullScreenImageViewer.vue?vue&type=template&id=68050e59&scoped=true&"
import script from "./FullScreenImageViewer.vue?vue&type=script&lang=js&"
export * from "./FullScreenImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenImageViewer.vue?vue&type=style&index=0&id=68050e59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68050e59",
  null
  
)

export default component.exports